export default __webpack_public_path__ + "static/nextgen-46de47ee333360fd46de994c63b8f185.svg";